import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IListViewState } from '@platform/core/types';
import type { IQuickFilterSelectProps } from './IQuickFilterSelectProps';
import { quickFilters } from './quickFilter';
import { useQuickCounts } from './useQuickCounts';

/**
 * «Фільтр [Усі записи · 471 ▾]» (UIUX patterns/filtering, прототип v4): нативний вибір 30px з лічильниками варіантів «Усі записи · Призначені
 * мені · Відкрито · Прострочено» (по всьому типу або в множині сторінки-списку `domain`); вибраний не «Усі» — акцентні рамка й текст. Діє
 * всередині пункту меню й запам'ятовується для пункту.
 */
export function QuickFilterSelect({ ws, rt, domain, value, onChange }: IQuickFilterSelectProps) {
  const { t } = useTranslation();
  const counts = useQuickCounts(ws, rt, domain);
  const label = (q: IListViewState['quickFilter']) => {
    const name = t(`listbar.quick.${q}`);
    return counts[q] === undefined ? name : t('listbar.counted', { label: name, count: counts[q] });
  };
  return (
    <select className={cx('lv-select lv-select--quick', value !== 'all' && 'is-on')} value={value} aria-label={t('listbar.quickFilter')}
      title={t('listbar.quickFilter')} onChange={(e) => onChange(e.target.value as IListViewState['quickFilter'])}>
      {quickFilters.map((q) => <option key={q} value={q}>{label(q)}</option>)}
    </select>
  );
}
